var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAARElEQVR42mMYXOD/GQTELu3e0gWDYCWY0gwqEHgg7kAcVAlCAVQaCsAK0jAVIPjuWBQAdbnDIaYCdAhTgABpmHCwRAAAbOVOm+JDamQAAAAASUVORK5CYII=";
  export default img;